import { render, staticRenderFns } from "./PromptForm.vue?vue&type=template&id=c24ef0f8&scoped=true&"
import script from "./PromptForm.vue?vue&type=script&lang=js&"
export * from "./PromptForm.vue?vue&type=script&lang=js&"
import style0 from "./PromptForm.vue?vue&type=style&index=0&id=c24ef0f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24ef0f8",
  null
  
)

export default component.exports